// extracted by mini-css-extract-plugin
export default {"container":"UI-z","error":"VI-z","disabled":"WI-z","submit":"XI-z","option":"YI-z","success":"ZI-z","failure":"_I-z"};